package link.erpango.quip.utils

import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext

object PlatformUtils: IPlatformManager {

    private var platformManager: IPlatformManager? = null

    fun create(platformManager: IPlatformManager) {
        if (this.platformManager != null) {
            return
        }
        this.platformManager = platformManager
    }

    override fun shareJsonData(jsonData: String) {
        platformManager?.shareJsonData(jsonData)
    }

    override fun openFile(filePath: String, mimeType: String) {
        platformManager?.openFile(filePath, mimeType)
    }

    override fun shareFile(filePath: String, mimeType: String) {
        platformManager?.shareFile(filePath, mimeType)
    }

    override fun vibrate(soft: Boolean, duration: Long) {
        platformManager?.vibrate(soft, duration)
    }

    override fun copyToClipboard(text: String) {
        platformManager?.copyToClipboard(text)
    }

}